import React, { useState, useEffect } from 'react';
import { useT } from '../i18n';
import LotteryView from '../components/Lottery/LotteryView';
import winningNumber from '../assets/utility/TicketK.webp';
import { ethers } from 'ethers';
import {
  CRANNILuckBlocksAddress,
  CRANNILuckBlocksWAddress,
  MultiCall,
  wsprovider,
  provider,
  bckpProvider,
  cranniAddress,
} from '../.config';
import { useTicketPrice, formatTicketPrice } from '../hooks/useTicketPrice';
import CRANNILuckBlocks from '../abi/CRANNILuckblocks.json';
import cranniLogo from '../assets/utility/CRANNI.png';
import Multicall from '../abi/Multicall.json';
import { threeDecimalNumber, explorerAddress } from '../utils';
import { useAccount, useWalletClient } from 'wagmi';
import lbDialog from '../components/UI/Modals/lbDialog';
import { useAppKitAccount } from "@reown/appkit/react";


let loadOneLogTimeout = null;

const CRANNI = ({ setShowDraw }) => {
  const ticketPrice = useTicketPrice(CRANNILuckBlocksAddress);
  const t = useT();
  const [loading, setLoading] = useState(true);
  const [ddrawid, setDDrawId] = useState(0);
  const [wdrawid, setWDrawId] = useState(0);
  const [winner, setWinner] = useState('');
  const [weeklyWinner, setweeklyWinner] = useState('');
  const [winnerTicket, setWinnerTicket] = useState('');
  const [weeklyWinnerTicket, setweeklyWinnerTicket] = useState('');
  const [winnerURL, setWinnerURL] = useState('');
  const [weeklyWinnerURL, setweeklyWinnerURL] = useState('');
  const [nextSpin, setNextSpin] = useState('');
  const [nextSpinWeekly, setNextSpinWeekly] = useState('');
  const [ticketBought, setTicketBought] = useState(0);
  const [ticketWeekly, setticketWeekly] = useState(0);
  const [dailyChance, setWinningChance] = useState(0);
  const [weeklyChance, setWinningChanceW] = useState(0);
  const [currentPriceWei, setCurrentPriceWei] = useState(0);
  const [jackpotUsd, setJackpotUsd] = useState(0);
  const [currentPriceWeiW, setCurrentPriceWeiW] = useState(0);
  const [jackpotUsdW, setJackpotUsdW] = useState(0);
  const [txs, setTxs] = useState([]);
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } = useAppKitAccount()
  const { data: walletClient } = useWalletClient();
  const [coinPrice, setCoinPrice] = useState(0);
  const [mkCap, setmkCap] = useState(0);

  const addTokenToMetaMask = async () => {
    if (!isConnected) {
      lbDialog.fire({
        title: t('tx.warning'),
        text: t('coin.noProvider'),
        icon: 'info',
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    try {

      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: cranniAddress,
            symbol: 'CRANNI', // Replace with your token's symbol
            decimals: 8, // Replace with your token's decimals
            image: '../assets/utility/CRANNI.png', // Replace with your token's logo URL
          },
        },
      });

      if (wasAdded) {
        lbDialog.fire({
          title: t('tx.success'),
          text: t('coin.tokenAdded'),
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        lbDialog.fire({
          title: t('tx.warning'),
          text: t('coin.tokenNotAdded'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      lbDialog.fire({
        title: t('tx.error'),
        text: error?.shortMessage || error?.reason || error?.message || String(error),
        icon: 'error',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const contract = new ethers.Contract(
    CRANNILuckBlocksAddress,
    CRANNILuckBlocks.abi,
    wsprovider
  );

  const bcontract = new ethers.Contract(
    CRANNILuckBlocksAddress,
    CRANNILuckBlocks.abi,
    bckpProvider
  );

  // Weekly Lottery Contract
  const Wcontract = new ethers.Contract(
    CRANNILuckBlocksWAddress,
    CRANNILuckBlocks.abi,
    bckpProvider
  );

  const httpcontract = new ethers.Contract(
    CRANNILuckBlocksAddress,
    CRANNILuckBlocks.abi,
    provider
  );

  const multicontract = new ethers.Contract(
    MultiCall,
    Multicall.abi,
    provider
  );
  async function getRaffleWinner() {
    const lotteryInfos = await multicontract.getLotteryInfos();
    const lotteryInfosW = await multicontract.getLotteryInfosW();
    let drawId = lotteryInfos[3][1];
    let weeklyDrawId = lotteryInfosW[3][1];
    let lastWinnerTicket = 0;
    let lastWeeklyWinnerTicket = 0;

    if (drawId > 0) {
      let pastDrawId = drawId - 1;
      let getlastWinnerTicket = await contract.jackpotWinHistory(pastDrawId);
      lastWinnerTicket = getlastWinnerTicket.id.toString();
    }
    if (weeklyDrawId > 0) {
      let pastWeeklyDrawId = weeklyDrawId - 1;
      let getlastWeeklyWinnerTicket = await Wcontract.jackpotWinHistory(
        pastWeeklyDrawId
      );
      lastWeeklyWinnerTicket = getlastWeeklyWinnerTicket.id.toString();
    }

    const getNextSpin = lotteryInfos[3][2] * 1000 + 86400000;
    const getNextSpinWeekly = lotteryInfosW[3][2] * 1000 + 604800000;

    const totalTickets = await contract.amountOfRegisters();
    const lastWinner = await contract.ourLastWinner();
    const lastWeeklyWinner = await Wcontract.ourLastWinner();
    const wTotalTickets = await Wcontract.amountOfRegisters();

    const jpWei = lotteryInfos[3][3];
    const jpUsd = lotteryInfos[3][4];
    const jpWeiW = lotteryInfosW[3][3];
    const jpUsdW = lotteryInfosW[3][4];

    const formatedTotalTicket =
      ((await ethers.utils.formatUnits(totalTickets.toString(), 'ether')) * 1e18).toFixed(0);
    const wformatedTotalTicket =
      ((await ethers.utils.formatUnits(wTotalTickets.toString(), 'ether')) *
      1e18).toFixed(0);
   
    const formatedJpWei = await ethers.utils.formatUnits(
      jpWei.toString(),
      8
    );
   
    const formatedJpUsd = await ethers.utils.formatUnits(
      jpUsd.toString(),
      6
    );
    const formatedJpWeiW = await ethers.utils.formatUnits(
      jpWeiW.toString(),
      8
    );
    const formatedJpUsdW = await ethers.utils.formatUnits(
      jpUsdW.toString(),
      6
    );

    const formatedWinningChance =
      ((1 / formatedTotalTicket) * 100).toFixed(4) + ' %';
    const formatedWinningChanceW =
      ((1 / wformatedTotalTicket) * 100).toFixed(4) + ' %';

    const winnerURLset = explorerAddress(lastWinner);
    const weeklywinnerURLset = explorerAddress(lastWeeklyWinner);

    setDDrawId(drawId.toString());
    setWDrawId(weeklyDrawId.toString());

    setCurrentPriceWei(parseFloat(formatedJpWei));

    setJackpotUsd(parseFloat(formatedJpUsd));

    setCurrentPriceWeiW(parseFloat(formatedJpWeiW));

    setJackpotUsdW(parseFloat(formatedJpUsdW));

    setLoading(false);

    setTicketBought(formatedTotalTicket);
    setticketWeekly(wformatedTotalTicket);

    setWinnerTicket(lastWinnerTicket);
    setweeklyWinnerTicket(lastWeeklyWinnerTicket);

    setNextSpin(parseInt(getNextSpin));
    setNextSpinWeekly(parseInt(getNextSpinWeekly));

    setWinningChance(formatedWinningChance);
    setWinningChanceW(formatedWinningChanceW);

    setWinner(lastWinner);
    setWinnerURL(winnerURLset);

    setweeklyWinner(lastWeeklyWinner);
    setweeklyWinnerURL(weeklywinnerURLset);
  }

  async function loadLogs() {
    const currentBlock = await wsprovider.getBlockNumber();
    const startBlock = currentBlock - 10000;  // testnet: 10000 mainnet: 83200;
    let eventFilter = bcontract.filters.LotteryLog();
    const items = await bcontract.queryFilter(
      eventFilter,
      startBlock,
      currentBlock
    );
    /*
    let weventFilter = Whttpcontract.filters.LotteryLog();
    const Witems = await Whttpcontract.queryFilter(weventFilter, startBlock, currentBlock);

    const filteredItems = Witems.filter(function (element) {
      return (
        element.args[2] ===
        "We have a new Weekly Raffle Winner"
      );
    });
    // setTxs(items);
    // console.log("filteredItems", filteredItems);
    if (filteredItems.length > 0) {
      items.push(filteredItems);
    }
    */
    //	console.log(items);
    setTxs(items);
  }

  async function loadOneLog() {
    let eventFilter = httpcontract.filters.LotteryLog();
    const currentBlock = await provider.getBlockNumber();
    const item = await httpcontract.queryFilter(
      eventFilter,
      currentBlock - 1,
      currentBlock
    );

    if (item.length > 0) {
      setTxs((prevTxs) => [...prevTxs, ...item]);
    }
  }

  async function loadPrice() {
    let coinPrice = await httpcontract.getLatestPrice() / 1000000;
    let mkcap = (coinPrice * 8888888).toFixed(2);

    setCoinPrice((coinPrice).toFixed(3).toString());
    setmkCap(mkcap.toString());

  }

  function loadDeferredIframe() {
    var iframe = document.getElementById('boggedchart');
    iframe.src =
      'https://teams.bogged.finance/embeds/chart?address=0x671078C0496Fa135a8c45fC7c9FA7B1501fD5146&chain=matic&charttype=line&theme=bg:00102AFF|bg2:00102AFF|primary:9F14F5FF|secondary:941BC8FF|text:F3F6FBFF|text2:F3F6FBFF|candlesUp:1BC870FF|candlesDown:ff4976ff|chartLine:A908DAFF&defaultinterval=15m&showchartbutton=false';
  }

  useEffect(() => {
    getRaffleWinner();
    loadLogs();
    loadPrice();
    //loadDeferredIframe();
  }, []);

  useEffect(() => {
    contract.on('LotteryLog', handleLotteryLogEvent);

    return () => {
      // Cleanup: Unsubscribe the event handler when the component unmounts
      contract.off('LotteryLog', handleLotteryLogEvent);
    };
  }, []); // Empty dependency array to run the effect only once

  // Define the event handler functions
  function handleLotteryLogEvent() {
    getRaffleWinner();
    if (!loadOneLogTimeout) {
      // Run loadOneLog after a delay if no timeout is already set
      loadOneLogTimeout = setTimeout(() => {
        loadOneLog();
        loadOneLogTimeout = null;
      }, 2000);
    }
  }

  return (
    <LotteryView
      coin={{
        label: 'CRANNI',
        symbol: 'CRANNI',
        logo: cranniLogo,
        website: 'https://docs.luckblocks.com/cranni-token',
      }}
      coinPrice={coinPrice}
      onAddToWallet={addTokenToMetaMask}
      loading={loading}
      ticketArt={winningNumber}
      ticketPrice={formatTicketPrice(ticketPrice)}
      ticketPriceTooltip={`${t('lottery.priceTooltip')} ${t('lottery.priceVote')}`}
      contractTickets={2}
      onBuyTickets={setShowDraw}
      txs={txs}
      daily={{
        title: t('coin.dailyDraw'),
        drawId: ddrawid,
        jackpotCrypto: threeDecimalNumber(currentPriceWei),
        jackpotUsd: jackpotUsd.toFixed(2),
        nextSpin: nextSpin,
        tickets: ticketBought,
        chance: dailyChance,
        winner: winner,
        winnerUrl: winnerURL,
        winnerTicket: winnerTicket,
        minimumNote: t('lottery.minDaily', { tickets: 10, pot: 155, seed: 150 }),
      }}
      weekly={{
        title: t('coin.weeklyDraw'),
        drawId: wdrawid,
        jackpotCrypto: threeDecimalNumber(currentPriceWeiW),
        jackpotUsd: jackpotUsdW.toFixed(2),
        nextSpin: nextSpinWeekly,
        tickets: ticketWeekly,
        chance: weeklyChance,
        winner: weeklyWinner,
        winnerUrl: weeklyWinnerURL,
        winnerTicket: weeklyWinnerTicket,
        minimumNote: t('lottery.minWeekly', { pot: 20 }),
      }}
    />
  );
};

export default CRANNI;
